import { render, staticRenderFns } from "./Terminal.vue?vue&type=template&id=63a1c8be"
import script from "./Terminal.vue?vue&type=script&lang=js"
export * from "./Terminal.vue?vue&type=script&lang=js"
import style0 from "../styles/github-markdown.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../styles/vs2015.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./Terminal.vue?vue&type=style&index=2&id=63a1c8be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports